var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:'svgdata svgdata'+this._uid,domProps:{"innerHTML":_vm._s(_vm.svgConstuct)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }